import React from 'react'
import { AiOutlineDelete } from 'react-icons/ai'
import { BsCheck2Square } from 'react-icons/bs'
import { CiEdit } from 'react-icons/ci'
import { Link } from 'react-router-dom'

const OwnershipTypesTable = ({ data, handleDelete, onChangeVal, initialVlue, handleChange, ownershipData, reset }) => {
  return (
    <>
      <div className="pageTable">
        <div className="tableLength d-flex form-search">

          <div className="dataTables_length">
            <input
              type="text"
              className="form-control"
              name="search"
              id="language_level"
              autoComplete="off"
              placeholder="search..."
              style={{ width: '600px' }}
              value={initialVlue?.search}
              onChange={handleChange}
            />
          </div>

          <div className="dataTables_length">
            <button type="button" className="btn btn-primary me-2" onClick={() => ownershipData(1)}>Search</button>
            <button type="button" className="btn btn-primary" onClick={() => reset(1)}>reset</button>
          </div>
        </div>
        <table className="table table-striped table-bordered ">
          <thead>
            {/* <tr role="row" className="filter">
                  <td>
                    <select id="lang" className="form-control" defaultValue={"lang"}>
                      <option value>Select Language</option>
                      <option value="ar">عربى</option>
                      <option value="en" selected="selected">
                        English
                      </option>
                      <option value="es">Español</option>
                      <option value="ur">اردو</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      placeholder="Ownership Types"
                    />
                  </td>
                  <td>
                    <select
                    defaultValue={"Is Active"}
                      className="form-select"
                    >
                      <option value={-1}>Is Active?</option>
                      <option value={1} selected="selected">
                        Active
                      </option>
                      <option value={0}>In Active</option>
                    </select>
                  </td>
                </tr> */}
            <tr role="row" className="heading">
              <th>Language</th>
              <th>Ownership Types</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.data?.map((item) => {
                return (
                  <tr key={item.id} role="row" className="odd">
                    <td className="sorting_1">{item?.language_id?.lang}</td>
                    <td>
                      <span dir="ltr">{item.ownership_type}</span>
                    </td>
                    <td>{item.is_active == 1 ? 'Yes' : 'No'}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-primary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`/admin/create-ownership-type/${item._id}`}
                            >
                              <CiEdit className="action_icons" />
                              Edit
                            </Link>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={() => { handleDelete(item._id) }}
                            >
                              <AiOutlineDelete className="action_icons" />
                              Delete
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <BsCheck2Square className="action_icons" />
                              Mark in Active
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default OwnershipTypesTable